import { useState, useEffect } from 'react';

const breakPoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1601
};

const useWidth = () => {
  const [width, setWidth] = useState();

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const down = point => {
    return width < breakPoints?.[point] ?? parseInt(point);
  };

  const up = point => {
    return width > breakPoints?.[point] ?? parseInt(point);
  };

  return { width, down, up };
};

export default useWidth;
